import ServiceCRUD from '../../../services/ServiceCRUD';
import { apiCase as http, apiInstagramChat } from '../../../http';

class ClientService extends ServiceCRUD {
  constructor() {
    super('cliente');
  }

  getAllFilter(
    entityName,
    page,
    limit,
    filters = {},
    isAccountInContact,
    accountId
  ) {
    const arrayFilters = Object.entries(filters);

    let query = `/entity/${entityName}/select?page=${page}&size=${limit}`;

    arrayFilters.forEach((el) => {
      query += `&${el[0]}=${el[1]}`;
    });

    if (isAccountInContact !== undefined) {
      query += `&isAccountInContact=${isAccountInContact}`;
    }
    if (accountId !== undefined) {
      query += `&accountId=${accountId}`;
    }

    return http.get(query);
  }

  wideSearch(params) {
    params = { ...params, requestLimit: 50 };
    return http.get('/client/wideSearch', { params });
  }

  async getImportFieldsByBroadcastListId(broadcastListId) {
    const result = await apiInstagramChat.get(
      `/broadcastList/${broadcastListId}/import-fields`
    );
    return result.data;
  }
}

export default new ClientService();
